import styled from 'styled-components';

export const IconContainer = styled.span`
  position: absolute;
  top: 50%;
  left: 0.75rem;
  transform: translateY(-50%);
`;
